/**
 * Monaco Editor 공통 옵션
 */
export const READ_ONLY_EDITOR_OPTIONS = {
  fontSize: 14,
  minimap: { enabled: true },
  scrollBeyondLastLine: false,
  automaticLayout: true,
  wordWrap: 'on',
  lineNumbers: 'on',
  readOnly: true,
  fontFamily: 'Consolas, "Courier New", monospace',
  tabSize: 4,
};

export const EDITABLE_EDITOR_OPTIONS = {
  ...READ_ONLY_EDITOR_OPTIONS,
  readOnly: false,
};
